
module.exports = function()
{
    this.type = "";
    this.message = "";
}